import { FilePlus, IconProps, ListBullets } from "@phosphor-icons/react";
import { Button, Checkbox, Divider, Form, message } from "antd";
import { MIXPANEL_EVENTS } from "constants/mixpanelEvents";
import { useApp } from "context/AppContext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import colors from "tailwindcss/colors";
import Mixpanel from "utils/mixpanel";
import { Pill } from "x-wings";
import CompletionModal from "pages/EDCFlow/components/MobileFlow/VisaForm/CompletionModal";

const QuestionnaireSubmit: React.FC<{ disabled: boolean }> = ({disabled}) => {
	const [searchParams] = useSearchParams();
	const isDocumentPage = searchParams.get("page") === "documents";
	const [isTNCAgreed, setIsTNCAgreed] = useState(false);
	const [showCompletionModal, setShowCompletionModal] = useState(false);
	const { order } = useApp();

	const iconProps: IconProps = {
		size: 40,
		color: colors.indigo["600"],
		className: "p-2 rounded-lg bg-white ring-1 ring-gray-900/10 shadow"
	};
	return (
		<>
		{showCompletionModal && (
			<CompletionModal countryName={order?.country?.name} onClose={() => window.location.reload()} />
		)}
		<div className="relative p-2 py-4 rounded-xl bg-gray-50 ring-1 ring-gray-900/10 shadow-xl mt-auto space-y-4 space-x-3">
			<Pill className="absolute top-4 right-4 bg-white" color="red" text="IMPORTANT" />
			{isDocumentPage ? <FilePlus {...iconProps} /> : <ListBullets {...iconProps} />}
			<p className="text-base text-gray-700 mt-5">
				We highly recommend taking the time to double-check that all the information is correct & complete to
				avoid any delays or issues during the review process.
			</p>
			{/* <div className="h-5 border-l border-l-solid border-l-primary-200 ml-1.5 mt-2 mb-2" /> */}
			<Checkbox className="" checked={isTNCAgreed} onChange={(e) => setIsTNCAgreed(e.target.checked)}>
				{isDocumentPage
					? "I have read & reviewed the documents myself"
					: "I have read & reviewed the questionnaire myself"}
			</Checkbox>
			<Divider className="border-gray-200 my-5" />

			<Button
				type="primary"
				size="large"
				disabled={!isTNCAgreed || disabled || showCompletionModal}
				onClick={() => {
					Mixpanel.track(MIXPANEL_EVENTS.QUESTIONNAIRE.QUESTIONNAIRE_SUBMITTED);
					setShowCompletionModal(true);
				}}>
				Submit & Continue
			</Button>
		</div>
		</>
	);
};

export default QuestionnaireSubmit;
